const StatusBadge = ({ status }) => {
  const isActive = status === "0";

  const styles = {
    padding: "2px 6px",
    fontSize: "11px", // You can change this value as needed
    borderRadius: "4px",
    display: "inline-block",
    backgroundColor: isActive ? "green" : "red",
    color: isActive ? "white" : "white",
  };

  return <span style={styles}>{isActive ? "Active" : "Deactivate"}</span>;
};

export default StatusBadge;
